import React from "react";

export default function FieldOptions({options}) {
    const optionsRender = options
        .filter(option => option.isVisible)
        .map(option => {
            return (
                <button
                    className="btn-field"
                    onClick={option.onClick}
                >
                    {!!option.icon && (
                        <option.icon/>
                    )}
                </button>
            )
        })

    return (
        <div className="space-x-2">
            {optionsRender}
        </div>
    )
}